// extracted by mini-css-extract-plugin
export var header = "_i3-0";